export const deliveryRoutes = [
    {
        path: '/delivery',
        component: () => import('@/features/delivery/views/DeliveryRouterView.vue'),
        children: [
            {
                path: ':deliveryId',
                name: 'delivery',
                component: () => import('@/features/delivery/views/DeliveryView.vue'),
            },
        ],
    },
]
